class ingredientItems extends HTMLElement {
    constructor() {
      super();
      this.clickEvent();
    }
  
    clickEvent = () => {
      let ingredientOpen = qsa('.open-article-js');
      ingredientOpen.forEach(item => {
        item.addEventListener('click', (e) => {
          let that = e.currentTarget;
          let wrapper = that.closest('.ingredient-item');
          let popup = qs('.common-popup-wrapper', wrapper);
          popup.classList.add('popup-open');
          document.body.classList.add('overflow-hidden');
        });
      });
      let closeIngredient = qsa('common-popup .close-icon');
      closeIngredient.forEach(otherItem => {
        otherItem.addEventListener('click', (e) => {
          let that = e.currentTarget;
          let popup = that.closest('.common-popup-wrapper');
          popup.classList.remove('popup-open');
          document.body.classList.remove('overflow-hidden');
        });
      });
    }
  }
  customElements.define('ingredient-items-group', ingredientItems);